<template>
  <div class="hello">
    <el-form-item :label="value.fieldCnName" :rules="!value.ifHide && (!value.styleSet || value.styleSet.showStyle!=7)?value.elRules:null" :prop="'fieldSet.'+fieldSetindex+'.defaultValStr'" class="Signing_form" >
      <template slot="label" v-if="(value.styleSet.titleNameHide!=2)">
        <span :style="value.styleSet.pageFieldNameStyleSet?value.styleSet.pageFieldNameStyleSet.styleSetCode:''" class="pageFieldNameStyleSet" kwName="pageFieldNameStyleSet">{{value.fieldCnName + ':'}}</span>
      </template>
      <el-input :ref="('field_'+fieldSetindex)" v-model="value.defaultValStr" size="mini" :type="'textarea'" class="searchInput" autofocus :placeholder="(value.styleSet.searchPlaceholder?value.styleSet.searchPlaceholder:'')" :style="value.styleSet.pageFieldValueStyleSet?value.styleSet.pageFieldValueStyleSet.styleSetCode:''" kwName="pageFieldValueStyleSet" @change="bindElementChange">
        <el-tooltip v-if="value.fieldDescribe" slot="append" effect="dark" :content="value.fieldDescribe" placement="top">
          <kw_icon  type="message_fill" />
        </el-tooltip>
      </el-input>
      <el-button type="primary" @click="utfcStateChange">{{utfcState?'停止盘点':'开始盘点'}}</el-button>
      {{stateHtml}}
    </el-form-item>
  </div>
</template>

<script>
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'kw_utfc',
  props: {
    value: {
      type: Object,
      default: {}
    },
    nowDataId: {
      default: 0
    },
    filedIndex:{
      type:String,
      default:null
    },
    hidden:{
      type:Boolean,
      default:false
    },
    pageSetInfo:{
      type: Object,
      default: {}
    },
    // 第几条数据
    nowDataIndex:{
      type: String,
      default: ''
    },
    //按钮是否根据角色权限限制
    isLimitButton:{
      type: Boolean,
      default: false
    },
    fieldSetindex:{
      type:Number,
      defaultStatus:0
    }
  },
  data() {
    return {
      buttonName:"开启盘点",
      stateHtml:"未开始盘点",
      utfcState:false,
    };
  },
  created() {
    var that = this;
    //加载时 判断是否是flutter中调用 如果是则调用开始判断方法
    
  },
  mounted() {
    var that = this;
    window.readUHFRToHtml = (uhfrStr) => {
      console.log("window.readUHFRToHtml=======================进入了====",uhfrStr);
      that.readUHFRToHtml(uhfrStr);
    }
    window.flutterResult = (uhfrStr) => {
      console.log("window.readStateToHtml=======================进入了====",uhfrStr);
      that.readStateToHtml(uhfrStr);
    }
    console.log("window==================",window);
  },
  beforeDestroy(){
    var ifFlutter = false;
    try {
        //调用flutter的停止读卡方法
        console.log("调用停止读卡方法----------_flutterStopUHFR-------");
        _flutterStopUHFR.postMessage("停止读卡");
        ifFlutter = true;
    } catch (error) {
        ifFlutter = false;
    } 
  },
  destroyed(){

  },
  watch:{
  },
  computed:{
  },
  components: {
  },
  methods: {
    /**
     * 判断状态变更
     */
    utfcStateChange(){
      var that = this;
      this.utfcState = !this.utfcState;
      if(this.utfcState) {
        var ifFlutter = false;
        try {
            //调用启动flutter的方法
            console.log("调用启动读卡--------_flutterStartUHFR---------");
            _flutterStartUHFR.postMessage("调用启动读卡");
            console.log("调用启动读卡成功--------_flutterStartUHFR---------");
            ifFlutter = true;
        } catch (error) {
          console.log("调用启动读卡失败--------_flutterStartUHFR---------",error);
            ifFlutter = false;
        } 
      } else {
        var ifFlutter = false;
        try {
            //调用flutter的停止读卡方法
            console.log("调用停止读卡方法----------_flutterStopUHFR-------");
            _flutterStopUHFR.postMessage("停止读卡");
            ifFlutter = true;
            that.stateHtml = "停止盘点中";
        } catch (error) {
            ifFlutter = false;
        } 
      }
    },
    /**
     * 读取到的标签信息 进行后续逻辑处理
     */
    readUHFRToHtml(uhfrStr) {
      console.log("uhfrStr=======================",uhfrStr);
      var that = this;
      // that.value.defaultValStr = uhfrStr;
      that.$set(that.value,"defaultValStr",uhfrStr);
      that.bindElementChange();
    },
    readStateToHtml(uhfrStr){
      this.stateHtml = uhfrStr;
      this.$forceUpdate();
    },
    bindElementChange(){
      var that = this;
      that.$emit("bindElementChange",that.value,that.fieldSetindex);
      // var fieldId = that.value.fieldId;
      // if(typeof(that["zdyValueChange_"+fieldId]) == "function") {
      //   console.log("fieldId=========2222222================",fieldId);
      //     that["zdyValueChange_"+fieldId](that,utils,pageUtils);
      // }
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
